import { connect } from 'react-redux'
import React from 'react'
import styled, { css } from 'styled-components'

const Wrapper = styled.div`
  text-align: center;
  border: 1px solid rgba(151, 151, 151, 0.28);
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.neutral.white};
  padding: 1.8rem;
  margin: 0 0.25rem 2rem 0.25rem;
  ${({ theme: { media } }) =>
    media.medium(css`
      min-height: ${(props) => (props.articles ? '30.7rem' : 'unset')};
      margin-bottom: 2rem;
      display: none;
    `)};
  ${({ theme: { media } }) =>
    media.large(css`
      display: block;
    `)};
  &:hover {
    box-shadow: ${({ theme }) => `0 0 10px 5px ${theme.colors.neutral.quarter}`};
  }
`

const AppIconContainer = styled.span`
  display: flex;
  align-items: center;
  flex-direction: column;
`

const QRCodeContainer = styled.span`
  display: flex;
  align-items: center;
`

const AppDownloadContainer = styled.span`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 15px;
`

const Title = styled.h2`
  && {
    font-size: 1.5rem;
    margin-bottom: 1rem;
    font-weight: 400;
    margin-top: 0.5rem;
  }
  color: ${({ theme }) => theme.colors.primary.nmBlue};
  text-transform: uppercase;
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.neutral.dime}`};
  padding-bottom: 0.375rem;
`

const Body = styled.p`
  && {
    font-size: 1.125rem;
    font-weight: 300;
    line-height: 1.7rem;
    margin-bottom: 2rem;
  }
`
const Disclamer = styled.span`
  color: ${({ theme }) => theme.colors.neutral.quarter};
  font-size: 0.625rem;
  display: block;
  margin-top: 2rem;
  line-height: 0.875rem;
`

const AppStoreImg = styled.img`
  height: 40px;
  width: 120px;
`

const QRCodeImg = styled.img`
  height: 80px;
`

function DidYouKnow ({ didYouKnow, articles }) {
  return (
    <Wrapper articles={articles.length}>
      <div className='light-bulb-on' />
      <Title>did you know?</Title>
      <Body dangerouslySetInnerHTML={{ __html: didYouKnow.body }} />
      {didYouKnow.href && <a href={didYouKnow.href}>{didYouKnow.cta} &#62;</a>}
      {didYouKnow.appStoreHref && (
        <AppDownloadContainer>
          <AppIconContainer>
            <a href={didYouKnow.appStoreHref}>
              <AppStoreImg alt='app store' src={didYouKnow.appStoreImg} />
            </a>
            <a href={didYouKnow.playStoreHref}>
              <AppStoreImg alt='play store' src={didYouKnow.playStoreImg} />
            </a>
          </AppIconContainer>
          <QRCodeContainer>
            <QRCodeImg alt='QR code for app download' src={didYouKnow.QRCode} />
          </QRCodeContainer>
        </AppDownloadContainer>
      )}

      <Disclamer dangerouslySetInnerHTML={{ __html: didYouKnow.disclaimer }} />
    </Wrapper>
  )
}

const mapStateToProps = (state) => ({
  didYouKnow: state.didYouKnow,
  articles: state.articles
})

export default connect(mapStateToProps)(DidYouKnow)
